module.exports = __webpack_public_path__ + "static/media/thumbnail.a287370b.jpg";